/*=========================================================================================
  File Name: module-misaorder.js
  Description: misaorder Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-remotesigning-state';
import mutations from './module-remotesigning-mutations';
import actions from './module-remotesigning-actions';
import getters from './module-remotesigning-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
